import { render, staticRenderFns } from "./view_project.vue?vue&type=template&id=2f5a8fe0&scoped=true"
import script from "./view_project.vue?vue&type=script&lang=js"
export * from "./view_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a8fe0",
  null
  
)

export default component.exports